export default {
    name: 'actions',
    default: {
        
    }
}

